<template>
	<router-view v-bind="propsToPass"></router-view>
</template>

<script>
export default {
	name: "TreeTargetLayout",

	computed: {
		propsToPass() {
			return this.$route.query;
		},
	},
};
</script>

<style>
</style>
